import { createContext } from "react";
import { IChangeNodesVisibility } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Utils/utils.models";

interface IOrgchartContext {
  changeNodesVisibility: ({
    clickedNodeId,
    isClickedNodeCollapsed,
  }: IChangeNodesVisibility) => null;
}

const OrgchartContext = createContext<IOrgchartContext>({
  changeNodesVisibility: () => null,
});

export default OrgchartContext;
